<template>
    <div class="modal" v-bind:class="{'modal--full': noOffset}">
        <slot></slot>
        <custom-button v-on:click="$emit('close')" modalclose>&times;</custom-button>
    </div>
</template>

<script>
import CustomButton from '../Button/CustomButton';

export default {
    name:       'ModalContent',
    components: {CustomButton},
    props:      {
        noOffset: {
            type:     Boolean,
            required: false,
            default:  () => false,
        }
    }
}
</script>
